import * as React from "react";
import ICompaniesListFilter from "./ICompaniesListFilter";
import ToolTip from "@appComponents/ToolTip/ToolTip";

import * as style from "./CompaniesListFilterStyle.module.scss"

const CompaniesListFilter: React.SFC<ICompaniesListFilter> = (props) => {
  const { selectedFilter, filtersList, filterFunction } = props;

  function isActive(value: string): string {
    return value === selectedFilter ? style.filterItemActive : "";
  }

  return (
    <ul className={style.filterList}>
      {filtersList.map((filter) => {
        if (!filter.enabled) {
          return (
            <li key={filter.name} className={style.filterItemDisabled}>
              {filter.name}
              <span className={style.filterCommingSoon} />
            </li>
          );
        }
        return (
          <li
            key={filter.name}
            className={[style.filterItem, isActive(filter.value)].join(" ")}
            onClick={() => filterFunction(filter.value)}
          >
            {filter.name}
            {filter.name === "Pre-listed" ? (
              <ToolTip text="These companies have not yet been selected for listing on bnktothefuture.com">
                &nbsp; &#9432;
              </ToolTip>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
};

export default CompaniesListFilter;
